// extracted by css-extract-rspack-plugin
export default {"root":"root-GYvbPc","currentAnchor":"currentAnchor-e6NPsn","menu":"menu-eX2sXJ","subTrigger":"subTrigger-kn9LfD","subMenu":"subMenu-MSX5f6","show":"show-HMgz3S"};